import { Input, Tooltip } from "antd";
import { OptionSelect_V2 } from "../../services/fomartUnit";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { ICarePolicyBenefitsTree, IprovinceChild, UnitLevel } from "../selectOptions/selectOptionsApi";
import { permissionGroupsByUnit } from "../groupPermission/groupPermissionApi";
import { IGroup } from "../groupCustomerV2/groupCustomerV2Api";


export const activeArray = [
  "Chưa kích hoạt", "Đang sử dụng"
]
export interface INationwide {
  id: number
  code: string
  title: string
  view: number
}
export interface IOptionNationwide1 {
  id: number
  code: string
  title: string
  children: Children1[]
}
export interface Children1 {
  id: number
  code: string
  title: string
  children: Children1[]
}
export interface DataTypeNationwide {
  codeArea: string;
  nameArea: string;
  view: number
  key: React.Key;

}

export interface OptionSelect {
  value: number;
  title: JSX.Element;
  children: OptionSelect[]
  label: string;
}

// Đon vị vùng miền
export interface DataTypeRegions {
  codeArea: string;
  nameArea: string;
  nationwide: string;
  view: number
  key: number;
}
export interface IRegions {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  nationwideTitle: string
}
export interface IDetailRegions {
  id: number
  code: string
  title: string
  view: number
  parentId: number
}
export interface IDetailUnit {
  id: number
  code: string
  title: string
  parentId: number
  b7EntityCode: string[]
}
export interface IOptionNationwide {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  children: Children[]
}

export interface Children {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  children: Children[]
}
export interface DataTypeUnit {
  codeUnit: string;
  unit: string;
  nationwide: string;
  region: string;
  key: number;
  view: number;
  parentId: number | null;
  b7EntityCode: string
}

// new data table tree
export interface DataTypeUnitV2 {
  id: number
  code: string
  title: string
  b7EntityCode?: string
  parentId: number
  view: number
  status: number
  level: number
  regionTitle: string
  nationwideTitle: string
  children: ChildrenV2[]
}

export interface ChildrenV2 {

  id: number
  code: string
  title: string
  b7EntityCode?: string
  parentId: number
  view: number
  status: number
  level: number
  regionTitle: string
  nationwideTitle: string
  children: ChildrenV2[]
}
// end


export interface IUnit {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  level: number
  b7EntityCode: string
  regionTitle?: string
  nationwideTitle?: string
}
export interface IIssuingUnit {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  level: number
  children: IIssuingUnit[]
}
export interface IIssuingUnitConvert {
  key: number
  title: JSX.Element
  children: IIssuingUnitConvert[]
}
// Đơn vị ban hàng
export const getListIssuingUnit = async (search?: string) => {
  const path = "issuingUnit/listIssuingUnit"
  const params = { search }
  const result: ResponseSuccessTotal<IIssuingUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export function convertIssuingUnitValueToTree(data: IIssuingUnit[]) {
  return data.map((item) => {
    const treeItem: IIssuingUnitConvert = {
      key: item.id,
      title: <p className='text-sm text-4B4B4B fw-500 font-medium'>{item.title}</p>,
      children: []
    };
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertIssuingUnitValueToTree(item.children);
    }
    return treeItem;
  });
}

// danh sách đơn vị
export const getListUnit = async (
  limit?: number, pageNumber?: number, search?: string) => {
  const path = "unit/listUnit"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<IUnit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListUnitV2 = async (
  limit?: number, pageNumber?: number, search?: string, listRegion?: number[]) => {
  const path = "unit/listUnit"
  const params = {
    limit, pageNumber, search, listRegion
  }
  const result: ResponseSuccessTotal<DataTypeUnitV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getDetailRegions = async (
  id: number) => {
  const path = "regions/infoRegions"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IDetailRegions> = await axiosClient.get(
    path, { params }
  );
  return result;
};

// danh sách đơn vị vùng miền
export const getListRegions = async (
  limit?: number, pageNumber?: number, search?: string) => {
  const path = "regions/listRegions"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<IRegions[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListNationwide = async (
  limit?: number, pageNumber?: number, search?: string) => {
  const path = "/unit/listNationwide"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<UnitLevel[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const getListNationwideV2 = async (
  limit?: number, pageNumber?: number, search?: string) => {
  const path = "nationwide/listNationwide"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<INationwide[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
// options
export const getListOptionNationwide = async (
  limit?: number) => {
  const path = "regions/listNationwide"
  const params = {
    limit
  }
  const result: ResponseSuccessTotal<IOptionNationwide[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export function findOptionByValue(tree: OptionSelect[], value: number): OptionSelect | undefined {
  for (const item of tree) {
    if (item.value === value) return item;
    if (item.children && item.children.length > 0) {
      const found = findOptionByValue(item.children, value);
      if (found) return found;
    }
  }
  return undefined;
}
export function convertNationwideValueToTree(data: UnitLevel[]) {
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title} (${item.code})`,
      title: <span className="text-sm font-regular text-344054">{item.title}<span className="text-sm font-regular text-98A2B3 pl-1">({item.code})</span></span>,
      children: []
    };
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertNationwideValueToTree(item.children);
    }
    return treeItem;
  });
}
export function convertProvinceValueToTree(data: IprovinceChild[]) {
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title}`,
      title: <span className="text-sm font-regular text-344054">{item.title}<span className="text-sm font-regular text-98A2B3 pl-1"></span></span>,
      children: []
    };

    return treeItem;
  });
}
export function convertNationwideValueToTree_V2(data: UnitLevel[]) {
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title} (${item.code})`,
      title: <span className="text-sm font-regular text-344054">{item.title}<span className="text-sm font-regular text-98A2B3 pl-1">({item.code})</span></span>,
      children: []
    };

    // Nếu có `children`, gọi đệ quy để xử lý
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertNationwideValueToTree_V2(item.children);
    }

    // Chỉ cho phép chọn mục nếu `level >= 3`
    // if (item.level >= 3) {
    return treeItem;
    // }

    // Nếu không đủ điều kiện chọn, giữ nguyên `children` nhưng loại bỏ khả năng chọn mục cha
    return {
      ...treeItem,
      selectable: false, // Thuộc tính tuỳ chọn (tuỳ vào thư viện bạn sử dụng, như Ant Design)
    };
  });
}


// convertTree
export function convertGroupValueToTree(data: IGroup[] | undefined | null) {
  if (!data) return [];
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title}`,
      title: <span className="text-sm font-regular text-344054">{item.title}</span>,
      children: []
    };

    // Nếu có `children`, gọi đệ quy để xử lý
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertGroupValueToTree(item.children);
    }

    // Chỉ cho phép chọn mục nếu `level >= 3`
    // if (item.level >= 3) {
    return treeItem;
    // }

    // Nếu không đủ điều kiện chọn, giữ nguyên `children` nhưng loại bỏ khả năng chọn mục cha
    return {
      ...treeItem,
      selectable: false, // Thuộc tính tuỳ chọn (tuỳ vào thư viện bạn sử dụng, như Ant Design)
    };
  });
}

export function convertGroupValueToTreeV2(data: ICarePolicyBenefitsTree[] | undefined | null) {
  if (!data) return [];
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title}`,
      title: <span className="text-sm font-regular text-344054">{item.title}</span>,
      children: []
    };

    // Nếu có `children`, gọi đệ quy để xử lý
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertGroupValueToTreeV3(item.children);
    }

    // Chỉ cho phép chọn mục nếu `level >= 3`
    // if (item.level >= 3) {
    return treeItem;
    // }


  });
}


export function convertGroupValueToTreeV3(
  data: ICarePolicyBenefitsTree[] | undefined | null
): OptionSelect[] {
  if (!data) return [];

  return data.map((item) => ({
    value: item.id,
    label: item.title,
    title: (
      <span className="text-sm font-regular text-344054">
        {item.title}
      </span>
    ),
    // Chỉ disable khi là node con
    selectable: false,
    
    // hoặc selectable: item.level === 1,
    children: convertGroupValueToTreeV3(item.children),
  }));
}

export const buildTreeData = (
  tree: OptionSelect[],
  selected: number[],
  currentValue?: number
): OptionSelect[] => {
  return tree.map(node => ({
    ...node,
    disabled:
      node.value !== currentValue &&
      selected.includes(node.value),
    children: buildTreeData(node.children ?? [], selected, currentValue),
  }));
};

export function convertNationwideTree(data: UnitLevel[]): OptionSelect_V2[] {
  return data.map((item) => {
    const treeItem: OptionSelect_V2 = {
      key: item.id,
      value: item.id,
      label: `${item.title} (${item.code}) `,
      title: <span key={item.id} className="text-sm font-regular text-344054">{item.title}<span className="text-sm font-regular text-98A2B3 pl-1">({item.code})</span></span>,
      children: [],
      level: item.level,
      parentId: item.parentId
    };

    // Nếu có `children`, gọi đệ quy để xử lý
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertNationwideTree(item.children);
    }

    // Chỉ cho phép chọn mục nếu `level >= 2`
    // if (item.level >= 2) {
    return treeItem;
    // }

    // Nếu không đủ điều kiện chọn, giữ nguyên `children` nhưng loại bỏ khả năng chọn mục cha
    return {
      ...treeItem,
      selectable: false, // Thuộc tính tuỳ chọn (tuỳ vào thư viện bạn sử dụng, như Ant Design)
    };
  });
}

export function convertNationwideTreeV2(data: permissionGroupsByUnit[]): OptionSelect_V2[] {
  return data.map((item) => {
    const treeItem: OptionSelect_V2 = {
      key: item.id,
      value: item.id,
      label: `${item.title} (${item.code}) `,
      title: <div className="d-flex  align-center  gap-2">
        <span key={item.id} className="text-sm font-regular text-344054">{item.title}<span className="text-sm font-regular text-98A2B3 pl-1">({item.code})</span></span>
        {
          item.groupPermission !== null && <div className="w-194-px h-8 rounded-2 border-F2F4F7 bg-F9FAFB px-4 d-flex align-center">  <Tooltip title={item.groupPermission.groupTitles} >
            <span className='tooltip-an text-BBBBBC font-regular'>{item.groupPermission.groupTitles}</span>
          </Tooltip></div>
        }

      </div>,
      children: [],
      level: item.level,
      parentId: item.parentId
    };

    // Nếu có `children`, gọi đệ quy để xử lý
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertNationwideTreeV2(item.children);
    }

    // Nếu không đủ điều kiện chọn, giữ nguyên `children` nhưng loại bỏ khả năng chọn mục cha
    return {
      ...treeItem,
      selectable: false, // Thuộc tính tuỳ chọn (tuỳ vào thư viện bạn sử dụng, như Ant Design)
    }
  });
}
// Hàm tìm các phần tử cha
export function findParentIds(data: UnitLevel[], childId: number): { id: number; level: number }[] {
  const parentIds: { id: number; level: number }[] = [];

  function findParents(node: UnitLevel, targetId: number): boolean {
    if (node.id === targetId) {
      return true;
    }

    for (const child of node.children) {
      if (findParents(child, targetId)) {
        parentIds.push({ id: node.id, level: node.level });
        return true;
      }
    }

    return false;
  }

  for (const item of data) {
    if (findParents(item, childId)) {
      break;
    }
  }

  return parentIds.reverse(); // Đảo ngược mảng để có thứ tự từ cha gần nhất đến cha xa nhất
}

export function convertRegionalValueToTree(data: IOptionNationwide1[]) {
  return data.map((item) => {
    const treeItem: OptionSelect = {
      value: item.id,
      label: `${item.title} (${item.code})`,
      title: <span className="text-sm font-regular text-344054">{item.title}</span>,
      children: []
    };
    if (item.children != null && item.children.length > 0) {
      treeItem.children = convertRegionalValueToTree(item.children);
    }
    return treeItem;
  });
}

export const detailNationwide = async (id: number) => {
  const path = "nationwide/infoNationwide"
  const params = { id }
  const result: ResponseSuccess<INationwide> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const detailUnit = async (id: number) => {
  const path = "unit/infoUnit"
  const params = { id }
  const result: ResponseSuccess<IDetailUnit> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const updateActiveNationwide = async (
  id: number) => {
  const path = "nationwide/activeNationwide"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const updateActiveRegions = async (
  id: number) => {
  const path = "regions/activeRegions"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const updateActiveUnit = async (
  id: number) => {
  const path = "unit/activeUnit"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};


export const updateNationwide = async (
  id: number, code: string, title: string) => {
  const path = "nationwide/editNationwide"
  const params = {
    id, code, title
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const updateRegions = async (
  id: number, code: string, title: string, parentId: number) => {
  const path = "regions/editRegions"
  const params = {
    id, code, title, parentId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};


export const updateUnit = async (
  id: number, code: string, title: string, parentId: number, b7EntityCode: string[]
) => {
  const path = "unit/editUnit"
  const params = {
    id, code, title, parentId, b7EntityCode
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};


export const addActiveNationwide = async (
  code: string, title: string
) => {
  const path = "nationwide/addNationwide"
  const params = {
    code, title
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};

export const addUnit = async (
  code: string, title: string, parentId: number, b7EntityCode: string[]
) => {
  const path = "unit/addUnit"
  const params = {
    code, title, parentId, b7EntityCode
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};
export const addRegions = async (
  code: string, title: string, parentId: number
) => {
  const path = "regions/addRegions"
  const params = {
    code, title, parentId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};

export const deleteUnit = async (
  id: number
) => {
  const path = "unit/deleteUnit"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};
export const deleteActiveNationwide = async (
  id: number
) => {
  const path = "nationwide/deleteNationwide"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};


export const deleteActiveRegions = async (
  id: number
) => {
  const path = "regions/deleteRegions"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};


// trải phẳng mảng unit tree
export const flattenUnits = (nodes: UnitLevel[]) => {
  const result: any = [];

  const dfs = (list: UnitLevel[]) => {
    for (const item of list) {
      result.push({
        value: item.id,
        label: `${item.title} (${item.code})`
      });

      if (Array.isArray(item.children) && item.children.length > 0) {
        dfs(item.children);
      }
    }
  };

  dfs(nodes);
  return result;
};